import Vue from 'vue'
import responsive from 'vue-responsive'
Vue.use(responsive)
